/**
 * useStreamNarrative — narrative entries, summary, and prompt-change batching state
 * Phase 4 (PRI-291): extracted from useStreamSession
 *
 * Owns: narrativeEntry, promptChangeForNarrative, narrativeSummary
 * Setters are returned to the orchestrator (useStreamSession) for the WS handler to call.
 */

import { useState } from 'react'
import type { NarrativeEntry } from '../../lib/narrative'

export interface StreamNarrativeReturn {
  narrativeEntry: NarrativeEntry | null
  setNarrativeEntry: React.Dispatch<React.SetStateAction<NarrativeEntry | null>>
  promptChangeForNarrative: {
    prompt: string
    wallClock: string
    elapsedS: number
    contextEntries?: Array<{ text: string; entry_type: string; wall_clock: string; elapsed_s: number }>
    bufferedEntries?: NarrativeEntry[]
  } | null
  setPromptChangeForNarrative: React.Dispatch<React.SetStateAction<StreamNarrativeReturn['promptChangeForNarrative']>>
  narrativeSummary: NarrativeEntry[] | null
  setNarrativeSummary: React.Dispatch<React.SetStateAction<NarrativeEntry[] | null>>
  resetNarrative: () => void
}

export function useStreamNarrative(): StreamNarrativeReturn {
  const [narrativeEntry, setNarrativeEntry] = useState<NarrativeEntry | null>(null)
  const [promptChangeForNarrative, setPromptChangeForNarrative] = useState<StreamNarrativeReturn['promptChangeForNarrative']>(null)
  const [narrativeSummary, setNarrativeSummary] = useState<NarrativeEntry[] | null>(null)

  const resetNarrative = () => {
    setNarrativeEntry(null)
    setPromptChangeForNarrative(null)
    setNarrativeSummary(null)
  }

  return {
    narrativeEntry,
    setNarrativeEntry,
    promptChangeForNarrative,
    setPromptChangeForNarrative,
    narrativeSummary,
    setNarrativeSummary,
    resetNarrative,
  }
}
